import React, { useState, useContext, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import IntegrationForm from './IntegrationForm';
import { Col, Row } from 'react-bootstrap';
import { IntegrationContext } from './Utils';
import { getEngineOptions } from './api';
import AppContext from 'Utils/AppContext';
import { STATUS } from 'Utils/styleTokens';

import {
  saveIntegration,
  getIntegration,
  getIntegrations,
  updateIntegration,
  deleteIntegration,
  testConnection
} from './api';
import { getErrorHandler } from 'Utils'
import { usePolling } from 'Hooks';
import {  FaGlobe } from 'react-icons/fa';
import PageHeader from 'Utils/PageHeader';
import FetchContainer from 'Utils/FetchContainer';
// import './DataSource.css';


const defaultIntegration = {
  id: -1,
  name: '',
  enginecode: 'DELPHIX_MASKING',
  enginetype: 'MASKING',
  location: '',
  password: '',
  port: 80,
  username: ''
}


const IntegrationEditor = (props) => {
  const { id } = useParams();
  const history = useHistory();

  // const init = async () => {
  // let integrationValue = defaultIntegration;
  // if (id) {
  //   integrationValue = await getIntegration(id);    
  //   }
  //   setIntegration(integrationValue);
  // }
  // init();
  const [integration, setIntegration] = useState(defaultIntegration);

  // console.log('IntegrationEditor INTEGRATION', integration);
  
  // const [integration, setIntegration] = useState(history.location.state.integration || defaultIntegration);
  const [error, setError] = useState('');
  const [fetchingData, setFetchingData] = useState(false);
  const [currentState, setCurrentState] = useState(null);
  const [success, setSuccess] = useState(false);
  const [connectionTest, setConnectionTest] = useState({});
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [saving, setSaving] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [engineOptions, setEngineOptions] = useState([]);
  const { loadIntegrationsHandler, setNotification } = useContext(AppContext);
  const handleError = getErrorHandler(setError);
  const context = {
    fetched,
    integration,
    setIntegration,
    success,
    setSuccess,
    fetchingData,
    currentState,
    setUnsavedChanges,
    saving
  };

  useEffect(() => {
    const fetch = async (id) => {
      if (!saving) setCurrentState('fetching');
      try {
        if (id > -1) {
          const integration = await getIntegration(id);
          setIntegration(integration);
        }

        const engineOptions = await getEngineOptions();
        if (engineOptions.integration_options) {
          const options = engineOptions.integration_options.map(option => ({
            value: option.enginecode,
            label: option.name,
            type: option.enginetype
          }));
          // console.log('IntegrationEditor ENGINE OPTIONS', options);
          setEngineOptions(options);
        }
      } catch(e) {
        handleError(e);
      }
      setFetched(true);
      setCurrentState(null);
    }
      fetch(id);
  }, [id]);


  const saveIntegrationHandler = async (integration) => {
    setSaving(true);

    try {      
      if (integration.id > -1) {
        await updateIntegration(integration, id);
      } else {
        await saveIntegration(integration);
      }
      await loadIntegrationsHandler();
      history.push('/integrations');

      // setNotification({
      //   header: 'Connection saved!',
      //   icon: (<FaRegThumbsUp size='25px' color='#23ad5c' />),
      //   body: <span>Connection successfully saved.</span>
      // });
    } catch(e) {
      handleError(e);
    }
    setSaving(false);
  }

  const deleteIntegrationHandler = async (integration) => {
    console.log('deleteIntegrationHandler', integration);
    setCurrentState('deleting');
    try {
      if (id) {
        await deleteIntegration(id);
      } 
      await loadIntegrationsHandler();
      history.push('/integrations');
    } catch(e) {
      handleError(e);
    }
    setCurrentState(null);
  }

  const testConnectionHandler = async (integration) => {
    console.log('testConnectionHandler', integration);
    setCurrentState('testing');
    try {
      const response = await testConnection(integration);
      
      if (response.authToken !== "null") {
        setNotification({
          header: 'Data Source Test Successful!',
          icon: (<FaGlobe size='25px' color={STATUS.success.dot} />),
          body: <span>Data Source test completed successfully.</span>
        });
      } else {
        // Show error notification for failed Data Source test
        setNotification({
          header: 'Data Source Test Failed',
          icon: (<FaGlobe size='25px' color={STATUS.danger.dot} />),
          body: <span>{'Data Source test failed'}</span>
        });
      }
    } catch(e) {
      handleError(e);
    }
    setCurrentState(null);
  }

  // const testConnectionHandler = async () => {
  //   setError(null);
  //   setCurrentState('testing');
  //   try {
  //     if (unsavedChanges) {
  //       await saveDataSource(connection, id);
  //       await loadConnectionsHandler();
  //       history.push('/sources/source-editor/' + connection.name);
  //     }
  //     const response = await testDataSource(connection);

  //     if (!response['JobRunId']) {
  //       const message = response.message || 'Error running connection test';
  //       throw new Error(message);
  //     }

  //     setConnectionTest({ 
  //       ...connectionTest,
  //       connection: connection.name,
  //       polling: 5000,
  //       jobRunId: response['JobRunId'],
  //       // status: 'RUNNING'
  //     });
  //   } catch(e) {
  //     handleError(e);
  //   }
  //   setCurrentState(null);
  // }

  return (
    <div className='p-0 h-100'>
      <FetchContainer fetchingData={currentState === 'fetching'} absolute={true}>
        <PageHeader
          header='Integration Editor'
          tooltip='Create or edit a integration to remove sensitive data from your data sources.'
          icon={FaGlobe}
        />
        <IntegrationContext.Provider value={context}>
          <div>
            <Row className='widget-row'>
              <Col  >
                <IntegrationForm
                  deleteIntegrationHandler={deleteIntegrationHandler}
                  saveIntegrationHandler={saveIntegrationHandler}
                  testConnectionHandler={testConnectionHandler}
                  engineOptions={engineOptions}
                  integration={integration}
                  fetchingData={fetchingData}
                  currentState={integration}
                />
              </Col>
              </Row>
            
          </div>
        </IntegrationContext.Provider>
      </FetchContainer>
    </div>
  );
}



export default IntegrationEditor;